<template>
  <div class="page_content module_course pg_broken_links" aria-label="Course Broken Links report">

    <course-header :course-id="uuid" :can-edit="true" class="header_course_about"></course-header>

    <div class="row page-content" v-html="brokenLinkInfo" v-if="allDataLoaded">
    </div>

    <div class="loader_v23_container" v-if="!allDataLoaded">
      <stretch class="loader_v23"></stretch>
    </div>

  </div>
</template>

<script>
import '../../../assets/module/css/course/courseAbout.min.css'
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import { PACKAGE } from '../../../package_constants'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'broken-links',
  props: ['uuid', 'loadDataFromServer'],
  components: {
    CourseHeader,
    CourseNav,
    Stretch
  },
  data: () => {
    return {
      brokenLinkInfo : '',
      allDataLoaded: false
    }
  },

  mounted () {
    this.showCheckBrokenLinks()
  },

  methods: {
    ...mapActions([
      'loadCheckBrokenLinks'
    ]),

    showCheckBrokenLinks () {
      this.loadCheckBrokenLinks(this.uuid).then(res => {
        this.brokenLinkInfo = res
        this.allDataLoaded = true
      })
    }
  }

}
</script>

<style>
.icon-container {
	width: 30px;
  height: 38px;
  float: left;
  position: relative;
}
.icon-container .ic-tag {
	font-size: 32px;
	position: absolute;
	margin-left: 0px;
	margin-top: 5px;
}
.clo-container {
	width: 92%;
	width: -moz-calc(100% - 48px);
  width: -webkit-calc(100% - 48px);
  width: -o-calc(100% - 48px);
  width: calc(100% - 48px);
	float: left;
	margin-left: 18px;
	margin-top: -4px;
}
.clo-container .clo-box {
	padding: 6px 12px;
  color: #fff;
  margin-bottom: 6px;
	margin-top: 6px;
  margin-right: 18px;
  float: left;
  width: 114px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/BrokenLinks.vue